<h1 mat-dialog-title>About</h1>

<mat-dialog-content>
  <table>
    <tr>
      <td class="pr-2 text-right"><strong>User:</strong></td>
      <td>{{ userName }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Employee ID:</strong></td>
      <td>{{ employeeNumber }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Home Cost Center:</strong></td>
      <td>{{ homeCostCenter }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Version:</strong></td>
      <td>{{ appVersion }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>Environment:</strong></td>
      <td>{{ envName }}</td>
    </tr>
    <tr>
      <td class="pr-2 text-right"><strong>LogRocket URL:</strong></td>
      <td>
        <button mat-raised-button class="!max-w-96 !justify-start" [cdkCopyToClipboard]="logRocket$ | async">
          <div class="line-clamp-1 whitespace-pre-line break-all">
            {{ logRocket$ | async }}
          </div>
        </button>
      </td>
    </tr>
  </table>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button type="button" (click)="clearLocalStorageAndReload()">Clear Local Storage</button>
</mat-dialog-actions>
